import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cpr00100-reissue" }
const _hoisted_2 = { class: "cpr00100-reissue-form" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from '../common/axios-common';
import DetailResultStatusCode from '../common/code/DetailResultStatusCode';
import AlertDialog from '../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../components/banner/PageHeaderBanner.vue';
import { isValidateEmail, isEmpty } from '../common/utils/validateUtils';
import ResultStatusCode from '../common/code/ResultStatusCode';
import MessageChip from '../components/chip/MessageChip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CPR00100',
  setup(__props) {

const router = useRouter();
// メールアドレス
const mailAddress = ref('');
// AlertDialog表示フラグ
const isAlertFlg = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * パスワード再発行
 */
const resetPassword = async () => {
  // Loading Start
  Loading.show();

  errMessage.value = '';
  isMessageChip.value = false;

  const formData = new FormData();
  formData.append('mail_address', mailAddress.value);

  await axios
    .post('/cpr001001/password-reissue', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          isAlertFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.NOT_EMAIL_EXIST_ERROR:
            case DetailResultStatusCode.UPDATE_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("パスワード再発行依頼")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createVNode(_component_q_form, {
      autofocus: "",
      greedy: "",
      novalidate: "",
      onSubmit: resetPassword,
      onValidationError: resetError
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_card, {
            bordered: "",
            flat: "",
            class: "bg-grey-2 cpr00100-form-card",
            style: {"padding":"50px 10%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("label", null, "会員ID（メールアドレス）", -1)),
                  _createVNode(_component_q_input, {
                    id: "mail_address",
                    modelValue: mailAddress.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mailAddress).value = $event)),
                    outlined: "",
                    name: "mail_address",
                    dense: "",
                    rules: [
                (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
                (val) => _unref(isValidateEmail)(val) || _ctx.$t('validation.email'),
              ],
                    "lazy-rules": "",
                    maxlength: "254",
                    type: "email",
                    "bg-color": "white",
                    class: "input-area left-input",
                    error: isMessageChip.value,
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                  }, null, 8, ["modelValue", "rules", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    color: "grey-7",
                    outline: "",
                    label: "戻る",
                    style: {"min-width":"120px","background":"var(--q-white) !important"},
                    to: { name: 'login' }
                  }),
                  _createVNode(_component_q_btn, {
                    type: "submit",
                    label: "送信",
                    icon: "mdi-email-outline",
                    color: "primary",
                    style: {"min-width":"120px"}
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: isAlertFlg.value,
      level: "information",
      confirmation: "",
      title: "パスワード再発行完了",
      text: [
        'パスワード再発行が完了致しました。',
        '登録されているメールアドレスに仮パスワードをご案内致しましたので、ご確認ください。',
        'ご案内メールが届かない場合は、お手数ですがお電話にてお問い合わせください。',
        '',
        'TEL：03-6262-6467',
      ],
      onComplete: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'login' })))
    }, null, 8, ["display"])
  ]))
}
}

})